import { render, staticRenderFns } from "./Cedente.vue?vue&type=template&id=58628d70&"
import script from "./Cedente.vue?vue&type=script&lang=js&"
export * from "./Cedente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports